import React from 'react';

function Spinner() {
  return (
    <div
      style={{
        display: 'block',
        marginTop: '2rem',
        marginBottom: '2rem',
        width: '100%',
      }}
    >
      <div
        style={{
          animation: '400ms linear infinite anim-rotate',
          borderBottom: '2px solid transparent',
          borderLeft: '2px solid #d3014c',
          borderRadius: '50%',
          borderRight: '2px solid transparent',
          borderTop: '2px solid #d3014c',
          boxSizing: 'border-box',
          height: 40,
          width: 40,
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      />
    </div>
  );
}

export default Spinner;
